import { gql } from "@apollo/client"

export const CLEAR_USER_NOTIFICATION = gql`
  mutation clearNotification($id: ID!, $isSinglePlan: Boolean!) {
    clearNotificationMsg(id: $id, isSinglePlan: $isSinglePlan) {
      success
    }
  }
`
